import { useQuery } from "@apollo/client";
import { PAGE_FOR_EDIT } from "./queries";
import type { PageForEdit } from "./types";

export function usePageData(id: string | undefined) {
  const result = useQuery<{ Page: PageForEdit | null }>(PAGE_FOR_EDIT, {
    variables: { id: id ?? "" },
    skip: !id,
    fetchPolicy: "cache-and-network",
  });
  return {
    page: result.data?.Page ?? null,
    loading: result.loading,
    error: result.error,
    refetch: result.refetch,
  };
}
